<template>
    <div v-bind="$attrs" class="app-loader"></div>
</template>

<script>
export default {
    name: "LoadingCircle",
};
</script>

<style scoped>
.app-loader {
    width: 48px;
    height: 48px;
    border: 3px solid #888;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    animation: app-loader-rotation 1s linear infinite;
}

.app-loader::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-bottom-color: #1188c2;
}

@keyframes app-loader-rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
